import { memo } from 'react';
import { Group, Text, Badge, Paper, Box, Progress } from '@mantine/core';
import { IconPlayerPlay, IconList, IconUsers } from '@tabler/icons-react';

/**
 * DashboardHeader component displays the current game state, PIN, question number, 
 * bot count, and a time remaining progress bar.
 */
const DashboardHeader = memo(({ gameState, questionNumber, botCount, form, timeLeft, totalTime }) => (
    <Paper p="md" bg="dark.8" radius={0} style={{ borderBottom: '1px solid var(--mantine-color-dark-5)' }}>
        <Group justify="space-between" align="center">
            <Group gap="xs">
                {gameState === 'lobby' && <Badge size="lg" color="white" variant="dot">Lobby</Badge>}
                {gameState === 'playing' && <Badge size="lg" color="orange" variant="dot">Game In Progress</Badge>}
                {gameState === 'question' && <Badge size="lg" color="green" variant="dot">Active Question</Badge>}
                {gameState === 'ended' && <Badge size="lg" color="red" variant="filled">Ended</Badge>}
            </Group>
            
            <Group gap="xl">
                <Group gap={6}>
                    <IconPlayerPlay size={16} color="gray" />
                    <Text fw={700} c="white">{form.pin}</Text>
                </Group>
                
                {gameState === 'question' && (
                    <Group gap={6}>
                        <IconList size={16} color="gray" />
                        <Text fw={700} c="white">Q{questionNumber}</Text>
                    </Group>
                )}

                <Group gap={6}>
                    <IconUsers size={16} color="gray" />
                    <Text fw={700} c="white">{botCount}/{form.amount}</Text>
                </Group>
            </Group>
        </Group>
        {gameState === 'question' && (
            <Box mt="sm">
                <Group justify="space-between" mb={4}>
                    <Text size="xs" c="dimmed">Time Remaining</Text>
                    <Text size="xs" fw={700} c={timeLeft < 5000 && timeLeft > 0 ? 'red' : 'cyan'}>{Math.ceil(timeLeft / 1000)}s</Text>
                </Group>
                <Progress value={(timeLeft / totalTime) * 100} color={timeLeft < 5000 ? 'red' : 'cyan'} animated size="sm" radius="xl" />
            </Box>
        )}
    </Paper>
));

export default DashboardHeader;
